import {AssetsRequestParams} from "../../../../infrastructure/models/params/assets-request-params";

export class PenaltiesBallMissedRequestParams extends AssetsRequestParams {
  constructor(width: Number, height: Number) {
    super(width, height);

    this.resourceName = this.resourceName + `/Missed`;
    this.version = 1
  }
}